///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../helpers/messages";
import CloseIcon from "./icons/CloseIcon";

function Modal(props) {
  return (
    <>
      {props.open && (
        <div className="responsive--dimmer">
          <div className="flex full-height items-center justify-center">
            <div
              style={props.modalStyle}
              className={`modal ${props.large && " modal__large "} ${
                props.xLarge && " modal__x-large"
              }`}
            >
              <button
                className={
                  props.closeButtonClass || "modal__close-button mr-24 mt-24"
                }
                onClick={props.handleClose}
              >
                <CloseIcon aria-hidden="true" height="16" width="16" />
                <span className="accessibility">
                  {messages.close.defaultMessage}
                </span>
              </button>
              <div className={props.titleClass || "modal__title"}>
                {props.title}
              </div>
              <div
                className={props.bodyClass || "pl-24 pr-24"}
                style={props.bodyStyle}
              >
                {props.children}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Modal;
